import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Link,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BusinessIcon from '@mui/icons-material/Business';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    first_name: '',
    last_name: '',
    role: 'consumer'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return false;
    }
    if (formData.password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const { confirmPassword, ...registerData } = formData;
      console.log('Intentando registro con datos:', registerData);
      
      const result = await register(registerData);
      if (result.success) {
        console.log('Registro exitoso, navegando a home');
        navigate('/');
      } else {
        console.log('Error en registro:', result.error);
        setError(result.error || 'Error al registrarse. Inténtalo de nuevo.');
      }
    } catch (error) {
      console.error('Error inesperado en registro:', error);
      setError('Error inesperado al registrarse. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="auth-container">
      <Paper className="auth-card" elevation={0}>
        <div className="auth-header">
          <div className="auth-logo">
            <BusinessIcon />
          </div>
          <Typography variant="h4" component="h1" className="auth-title">
            Crear Cuenta
          </Typography>
          <Typography variant="body1" className="auth-subtitle">
            Únete a MetalConnect y conecta con el mercado de metales
          </Typography>
        </div>

        {error && (
          <Alert severity="error" className="error-message">
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} className="auth-form">
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <div className="form-field" style={{ flex: 1 }}>
              <TextField
                required
                fullWidth
                id="first_name"
                label="Nombre"
                name="first_name"
                autoComplete="given-name"
                value={formData.first_name}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
            <div className="form-field" style={{ flex: 1 }}>
              <TextField
                required
                fullWidth
                id="last_name"
                label="Apellido"
                name="last_name"
                autoComplete="family-name"
                value={formData.last_name}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </Box>

          <div className="form-field">
            <TextField
              required
              fullWidth
              id="username"
              label="Nombre de Usuario"
              name="username"
              autoComplete="username"
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-field">
            <TextField
              required
              fullWidth
              id="email"
              label="Correo Electrónico"
              name="email"
              type="email"
              autoComplete="email"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-field">
            <FormControl fullWidth>
              <InputLabel id="role-label">Tipo de Cuenta</InputLabel>
              <Select
                labelId="role-label"
                id="role"
                name="role"
                value={formData.role}
                label="Tipo de Cuenta"
                onChange={handleChange}
                disabled={loading}
              >
                <MenuItem value="consumer">Consumidor</MenuItem>
                <MenuItem value="supplier">Proveedor</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="form-field">
            <TextField
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="new-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-field">
            <TextField
              required
              fullWidth
              name="confirmPassword"
              label="Confirmar Contraseña"
              type="password"
              id="confirmPassword"
              autoComplete="new-password"
              value={formData.confirmPassword}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <Button
            type="submit"
            fullWidth
            className={`auth-button ${loading ? 'loading' : ''}`}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? 'Creando cuenta...' : 'Crear Cuenta'}
          </Button>
        </Box>

        <div className="auth-divider">
          <span>o continúa con</span>
        </div>

        <div className="social-auth">
          <Button className="social-button" variant="outlined">
            Google
          </Button>
          <Button className="social-button" variant="outlined">
            LinkedIn
          </Button>
        </div>

        <div className="auth-footer">
          <Typography variant="body2">
            ¿Ya tienes una cuenta?{' '}
            <Link component={RouterLink} to="/login">
              Inicia sesión aquí
            </Link>
          </Typography>
        </div>
      </Paper>
    </Box>
  );
};

export default Register; 